// extracted by mini-css-extract-plugin
export default {"flag":"_3RIsrC_-KQF6EwInhZ6E2X","languagePopover":"_1EFEE8GhO84m5ZsRzpjFOf"};